
<div class="d-flex flex-column h-100">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between py-3">
        <div class="d-flex h-100">
            <button type="button" class="icon-btn mb-1" (click)="backToLanding()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
                </svg>
            </button>
            <h6 class="m-0 text-nowrap" cvLocalizedText langSection="Dashboards_Landing" langKey="Dashboard_Library">Dashboard Library</h6>
        </div>
    </div>

    <div class="d-flex flex-grow-1 pb-3" style="min-height: 0;">
        <div class="d-flex flex-column col p-0 mr-4">
            <div class="d-flex justify-content-between align-items-center my-3">
                <button type="button" class="btn btn-primary btn-icon ml-0"
                    (click)="openNewDashboardView(workspaceNewTabViewMode.Existing)"
                    [attr.title]="createTooltip"
                    *ngIf="hasCreatePermission"
                    [disabled]="!canCreateNewDashboard">
                    <svg>
                        <use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
                    </svg>
                    <span cvLocalizedText langSection="Left_Nav_Popup" langKey="New_Dashboard">New Dashboard</span>
                </button>

                <div *ngIf="!hasCreatePermission"></div>

                <div class="search-box live-search w-auto">
                    <input type="search" class="form-control" style="box-sizing: border-box;"
                        cvLocalizedPlaceholder langSection="Responsive_Dashboard" langKey="Search"
                        [(ngModel)]="searchFilter"
                    />
                    <span class="clear-input" [hidden]="searchFilter.length === 0" (click)="clearSearch()"></span>
                </div>
            </div>

            <cv-manage-available-dashboards
                class="flex-fill"
                [searchFilter]="searchFilter"
                [toolbar]="false"
                (selectionChanged)="this.selectedDashboards = $event"
                (selectionChanged)="selectedDashboards = $event"
                (shareClicked)="onShareClickedTemp($event)"
                [allowManagement]="true"
            ></cv-manage-available-dashboards>
        </div>

        <cv-selected-dashboard-details
            class="p-3 card"
            style="width: 360px; margin-top: 64px; transition: none;"
            [enableEdit]="false"
            [selectedDashboards]="selectedDashboards"
        ></cv-selected-dashboard-details>
    </div>
</div>

<!-- Share Popup -->
<cv-angular-assign-tool
    type="dashboardSharing"
    headerText="Share Settings"
    buttonText="Apply"
    [singleAdd]="true"
    [singleType]="false"
    [(showPopup)]="showAssignTool"
    [dataTransfer]="selectedDashboards"
    [useLogins]="true" [showAll]="true"
></cv-angular-assign-tool>
